import styled from 'styled-components';
import { addPxSuffix } from '@/src/helpers';

const Image = styled.img<{
  $height?: string | number;
  $width?: string | number;
  $widthDesktop?: string | number;
  $maxWidth?: string | number;
  $maxHeight?: string | number;
  $minHeight?: string | number;
  $radius?: string | number;
  $margin?: string | number;
  $aspectRatio?: string;
  $mobileAspectRatio?: string;
  $desktopAspectRatio?: string;
}>`
  width: ${({ $width }) => addPxSuffix($width || 'auto')};
  height: ${({ $height }) => addPxSuffix($height || 'auto')};
  aspect-ratio: ${({ $aspectRatio, $mobileAspectRatio }) =>
    $mobileAspectRatio ? $mobileAspectRatio : $aspectRatio || 'auto'};
  max-width: ${({ $maxWidth }) => addPxSuffix($maxWidth || 'auto')};
  max-height: ${({ $maxHeight }) =>
    $maxHeight ? addPxSuffix($maxHeight || '100%') : '100%'};
  min-height: ${({ $minHeight }) => addPxSuffix($minHeight || 0)};
  border-radius: ${({ $radius }) => ($radius ? addPxSuffix($radius) : 0)};
  -webkit-border-radius: ${({ $radius }) =>
    $radius ? addPxSuffix($radius) : 0};
  -moz-border-radius: ${({ $radius }) => ($radius ? addPxSuffix($radius) : 0)};
  margin: ${({ $margin }) => addPxSuffix($margin || 0)};
  transform: translateZ(0);
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  object-fit: cover;

  @media (min-width: ${({ theme }) => theme.breakpoints.l}) {
    width: ${({ $widthDesktop, $width }) =>
      addPxSuffix($widthDesktop || $width || 'auto')};

    aspect-ratio: ${({ $aspectRatio, $desktopAspectRatio }) =>
      $desktopAspectRatio || $aspectRatio || 'auto'};
  }
`;

const Overlay = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(
    0deg,
    rgba(0, 0, 0, 0.34) 0%,
    rgba(0, 0, 0, 0.34) 100%
  );
  object-fit: contain;
`;

const S = {
  Image,
  Overlay,
};

export default S;
